import React, { createContext, useState, useEffect } from "react";
import api from "../admin/api/api";

export const WishlistContext = createContext();

export const WishlistProvider = ({ children }) => {

  const [wishlistItems, setWishlistItems] = useState([]);

  const user = JSON.parse(localStorage.getItem("user"));

  useEffect(() => {
    if(user){
      loadWishlist();
    }
  }, []);

  const loadWishlist = async () => {

    try {

      const res = await api.get(`/Wishlist/user/${user.userId}`);

      setWishlistItems(res.data);

    } catch (err) {
      console.log(err);
    }
  };

  const addToWishlist = async (productId) => {

    try {

      await api.post(`/Wishlist/add`,
        {
          userId: user.userId,
          productId: productId
        }
      );

      loadWishlist();

    } catch (err) {
      console.log(err);
    }
  };

  const removeFromWishlist = async (productId) => {
    
    await api.delete(`/Wishlist/remove/${user.userId}/${productId}`);

    loadWishlist();
  };

  return (
    <WishlistContext.Provider
      value={{
        wishlistItems,
        addToWishlist,
        removeFromWishlist
      }}
    >
      {children}
    </WishlistContext.Provider>
  );
};